import React, { useState, useEffect, useMemo } from 'react'
import Lottie from 'react-lottie'
import { Container } from '@mui/material'
import Button from 'components/Button/Index'
import WelcomeAnimation from 'assets/animations/welcome.json'
import { IRestaurantDetailData } from 'interfaces/restaurant'
import Layout from 'components/Layout/Layout'
import { useSelector } from 'react-redux'
import {
  restuarantData,
  faqUrlData,
  paymentEnableData,
} from 'features/restaurant/restaurant'
import { menuList } from 'features/menu/menu'
import { isMenuInProgress } from 'features/menuProgressState/menuProgressState'
// import { useNavigate } from 'react-router-dom'
import { Dish, DishWhite, FAQ, FAQWhite, NoLogo } from 'assets/images'
import { IFaqUrlResponse } from 'interfaces/common'
import FaqDialog from 'components/FAQdialog/Index'
import { tabData } from 'features/tab/tab'
import { ITab } from 'interfaces/tab'
import PayNowFooter from 'components/Footer/PayNowFooter'
import { getViewTabRoute, isOrderingEnabledAndHealthy } from 'utility/helper'

function Landing() {
  const tab: ITab = useSelector(tabData)
  const [logoVisible, setLogoVisible] = useState(false)

  const viewTabRoute = useMemo(() => {
    return getViewTabRoute()
  }, [])
  const restaurantData: IRestaurantDetailData = useSelector(restuarantData)
  const faqUrlFromRedux = useSelector(faqUrlData)
  const [faqUrl, setFaqUrl] = useState<IFaqUrlResponse>(faqUrlFromRedux)
  const [url, setUrl] = useState('')
  const [faqDialog, setOpenFaqDialog] = useState(false)
  const menus = useSelector(menuList)
  const menuLoading = useSelector(isMenuInProgress)
  const paymentEnable = useSelector(paymentEnableData)

  // Check if menus are available
  const hasMenus = menus && menus.length > 0

  useEffect(() => {
    if (faqUrlFromRedux) {
      setFaqUrl(faqUrlFromRedux)
    }
  }, [faqUrlFromRedux])

  return (
    <>
      <Layout title="Home | FasTab">
        {/* wrapper start */}
        <section className="wrapper main-menu">
          <Container maxWidth="md">
            {/* animation wrapper start */}
            <div className="animation-wrapper">
              <Lottie
                options={{
                  loop: false,
                  autoplay: true,
                  animationData: WelcomeAnimation,
                  rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice',
                  },
                }}
                height={250}
                width={300}
                eventListeners={[
                  {
                    eventName: 'complete',
                    callback: () => {
                      setLogoVisible(true)
                    },
                  },
                ]}
              />
              <div className={`logo-wrapper ${logoVisible ? 'show' : ''}`}>
                {restaurantData?.businessLogoPath ? (
                  <img src={restaurantData?.businessLogoPath} alt="FasTab" />
                ) : (
                  <img src={NoLogo} alt="FasTab" />
                )}
              </div>
            </div>
            {/* animation wrapper end */}
            {/* Only show Order Now/View Menu button if menus are available and loaded */}
            {hasMenus && !menuLoading && (
              <Button
                variant="contained"
                color="secondary"
                isTypeLink
                title={
                  isOrderingEnabledAndHealthy(menus, paymentEnable)
                    ? 'Order Now'
                    : 'View Menu'
                }
                className="mb-20 lg-font"
                to={
                  isOrderingEnabledAndHealthy(menus, paymentEnable)
                    ? '/order-menu'
                    : '/view-menu'
                }
                linkState={{ establishmentId: tab.establishmentId }}
              >
                <img src={DishWhite} alt="Order" className="active" />
                <img src={Dish} alt="Order" className="default" />
                <span>
                  {isOrderingEnabledAndHealthy(menus, paymentEnable)
                    ? 'Order Now'
                    : 'View Menu'}
                </span>
              </Button>
            )}
            <Button
              variant="contained"
              color="secondary"
              isTypeLink
              className="mb-20 lg-font"
              title="View Tab"
              to={viewTabRoute}
              linkState={{
                establishmentId: tab.establishmentId,
                isFromSplit: true,
              }}
            >
              <img src={DishWhite} alt="Dish" className="active" />
              <img src={Dish} alt="Dish" className="default" />
              <span>View Tab</span>
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className="mb-20 lg-font"
              title="FAQ"
              onClick={() => {
                setOpenFaqDialog(true)
                setUrl(faqUrl.faqUrl)
              }}
            >
              <img src={FAQWhite} alt="FAQ" className="active" />
              <img src={FAQ} alt="FAQ" className="default" />
              <span>FAQ</span>
            </Button>
          </Container>
        </section>
        {/* wrapper end */}
        <PayNowFooter isYourTabTitle />
      </Layout>
      <FaqDialog
        open={faqDialog}
        url={url}
        onClose={() => setOpenFaqDialog(false)}
      />
    </>
  )
}

export default Landing
